export default __webpack_public_path__ + "static/media/YellowFish.c441fee7.png";